import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { image_url } from "../../config/Api";


export const OurExpertise = ({data}) => {
    return (
        <Fragment>

        {data && data.map((row,key)=>{
            return(
                <Fragment>
                    <section class="our-expertise">
                        <div class="container">
                            <div class="title-black text-center">
                                <h1>{row.listcontent.description}</h1>
                            </div>
                            <div class="row">
                                
                                {row.list && row.list.map((prow,key)=>{

                                    return(
                                        <Fragment>

                                            <div class="col-lg-4 col-md-6 col-sm-6">
                                                <div class="expertise-single">
                                                    <img src={image_url+''+prow.image} alt=""></img>
                                                    <h3>{prow.title}</h3>
                                                    <p>{prow.description}</p>
                                                </div>
                                            </div>


                                        </Fragment>
                                    )
                                })}

                                            
                                
                                
                                
                            </div>
                        </div>
                    </section>
                </Fragment>
            )
        })}

        </Fragment>
    )
}

